//
//
//
//
//
//

import Search from './Search'
import Tables from './Table'
import { mapActions,mapGetters } from 'vuex'
export default {
    components:{
        Search,Tables
    },
    data(){
        return{
            searchData:{
                discountName:'',
                startBuyPrice:'',
                endBuyPrice:'',
                startDiscount:'',
                endDiscount:''
            },
            pageConfig:{
                current:1,
                pageSize:10
            }
        }
    },
    computed:{
        ...mapGetters('search',{
            list:'getTable',
            total:'getTotal'
        })
    },
    methods:{ 
        ...mapActions('search',{
            setTableAction:'setTableAction'
        })
    },
    created(){
        this.setTableAction()
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/view.vue